import products from './products'
import canonical from './canonical'
import whatsHappening from './whats-happening'

const canonicalLink = {
  products,
  canonical,
  whatsHappening,
}

export default canonicalLink
